import React from 'react';
import PropTypes from 'prop-types';

import CheckBox from 'components/CheckBox';
import { NUMERICALSUMMARY_COLUMNS, CATEGORICAL_SUMMARY_COLUMNS } from '../../../../NumericalSummary/columns';

const SelectedColumnComponent = props => (
  <div className="mb-25">
    <div className="mb-15">
      <div className="main-checkbox-filter mb-5">
        {props.type === 'numerical' && NUMERICALSUMMARY_COLUMNS[props.name] ? (
          <CheckBox
            checked={props.isVisible}
            onChange={props.onVisibilityCheckboxChange}
          >
            {NUMERICALSUMMARY_COLUMNS[props.name]}
          </CheckBox>
        ) : null }

        {props.type === 'categorical' && CATEGORICAL_SUMMARY_COLUMNS[props.name] ? (
          <CheckBox
            checked={props.isVisible}
            onChange={props.onVisibilityCheckboxChange}
          >
            {CATEGORICAL_SUMMARY_COLUMNS[props.name]}
          </CheckBox>
        ) : null }
      </div>
    </div>
  </div>
);

SelectedColumnComponent.propTypes = {
  // values
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,

  // callbacks
  onVisibilityCheckboxChange: PropTypes.func.isRequired
};

export default SelectedColumnComponent;
